import { AlertController, Events, Platform, LoadingController, Loading } from 'ionic-angular';
import { AppAvailability } from '@ionic-native/app-availability';
import { AppVersion } from '@ionic-native/app-version';
import { BrowserTab } from '@ionic-native/browser-tab';
import { DatePipe } from '@angular/common';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { Injectable } from '@angular/core';

import { AreaLocalProvider } from '../providers/area-local/area-local';
import { BrComDao } from './BrComDao';
import { ServidorProvider } from '../providers/servidor/servidor';
import { Contato } from '../models/contato';
import { ContatoLocalProvider } from '../providers/contato-local/contato-local';
import { PushService } from './PushService';
import { readValueFromConfig, keyGen } from '../lib/util';
import { RemoteService } from './RemoteService';

var brComServiceInstance: BrComService;

export interface radio {
  link: string,
  titulo: string
}

@Injectable()
export class BrComService {

  public pushService: PushService;
  private datePipe: DatePipe;
  private appDomain: string;
  
 constructor(public brComDao: BrComDao, private remoteService: RemoteService, public alertCtrl: AlertController, 
  public events: Events, private browserTab: BrowserTab, private appVersion: AppVersion, public platform: Platform, 
  private appAvailability: AppAvailability, private fileTransfer: FileTransfer, private loadingController: LoadingController, 
  private contatoLocalProvider: ContatoLocalProvider, private areaLocalProvider: AreaLocalProvider) {
    brComServiceInstance = this;
    this.datePipe = new DatePipe("pt-BR");
    brComServiceInstance.events.subscribe("marcaNaoLidoEfetivo", brComServiceInstance.marcaNaoLidoEfetivo);
    this.appDomain = "";
    this.definirAppDomain();
  }

  private async definirAppDomain() {
    brComServiceInstance.appDomain = brComServiceInstance.readAppDomain();
  }

  public getAppDomain():string {
    return brComServiceInstance.appDomain;
  }

  public getIdDevice(): any {
    return readValueFromConfig(brComServiceInstance.pushService.localStorageKeyName(), 'idDevice');
  }

  async notificaMensagemRecebida(msg: any) {
    if (msg.idMensagemUsuario && (msg.statusMensagemRecebida != true)){
      let idDevice = readValueFromConfig(await brComServiceInstance.pushService.localStorageKeyName(), 'idDevice');
      brComServiceInstance.remoteService.remoteCallSemLoading("registraMensagemRecebida", {id_mensagem_usuario:msg.idMensagemUsuario, id_device: idDevice}, function(result: any) {
        if(result && result.executado) {
          brComServiceInstance.brComDao.atualizaStatusMensagemRecebida(msg.codEmpresa, msg.idMensagemUsuario);
        }
      });
    }
  }

  async notificaMensagensLidas(codEmpresa: number) {

    let listaId = [];
    let mensagensNaoLidas = localStorage['lista_mensagens_nao_lidas_'+codEmpresa];
    let idDevice = readValueFromConfig(await brComServiceInstance.pushService.localStorageKeyName(), 'idDevice');
    if (mensagensNaoLidas){
      listaId = JSON.parse(mensagensNaoLidas);
    }
    
    if (listaId.length > 0){
      brComServiceInstance.remoteService.remoteCallSemLoading("registraMensagensLidas", {id_mensagem_usuarios: JSON.stringify(listaId), id_device: idDevice}, function(result: any) {
        if (result){
          for (let resposta of result){
            if (resposta.executado){
              brComServiceInstance.brComDao.atualizaStatusMensagemLida(codEmpresa, resposta.idMensagemUsuario);
              listaId.splice(listaId.indexOf(resposta.idMensagemUsuario),1);
            }
          }
          localStorage['lista_mensagens_nao_lidas_' + codEmpresa] = JSON.stringify(listaId);
        }
      });
    }
  }

  marcaNaoLidoEfetivo(params: any) {
    brComServiceInstance.brComDao.marcaStatusMsgsNaoLidaEmpresa(params.codEmpresa, true);
  }
  
  limparDados() {
    brComServiceInstance.brComDao.limpaDados();
  }

  public readAppDomain(): string {
    /*var nome = "brcomunique";
    try {
      var pn = await brComServiceInstance.appVersion.getPackageName();
      pn = pn.substring(pn.indexOf('.mobile') + 8);
      if (pn != "") {
        nome = pn;
      }
    } catch (e) {
    }
    //return nome;*/
    return 'lince'; //trocar quando gerar nova versão
  }

  public  localStorageKeyName(): string {
    let ip = ServidorProvider.getIpPortaServidorPush();
    while (ip.indexOf(".") != -1)
      ip = ip.replace('.', '_');
    while (ip.indexOf(":") != -1)
      ip = ip.replace(':', '_');
   /* let r: string;
    let ip = ServidorProvider.getIpPortaServidorPush();
    while (ip.indexOf(".") != -1)
      ip = ip.replace('.', '_');
    while (ip.indexOf(":") != -1)
      ip = ip.replace(':', '_');

    let appDomain = brComServiceInstance.readAppDomain();

    if (appDomain != "brcomunique")
      r = "push_info_brcomunique_" + appDomain + "_" + ip;
    else
      r = "push_info_" + appDomain + "_" + ip;

    //return r;*/
    return `push_info_brcomunique_lince_${ip}`; //trocar quando gerar nova versão
  }

  async limpar() {

    for (let empresa of brComServiceInstance.obtemGrupos()) {
      if (empresa.Autenticado) {
        await brComServiceInstance.liberaUsuario(empresa.CodEmpresa, empresa.CodUsuario);
      }
    }

    brComServiceInstance.limparDados();
    //brComServiceInstance.iniciaPaginaFoneCpf({});
    brComServiceInstance.pushService.init();
  }

  async liberaUsuario(codEmpresa: number, codUsuario: number) {
    let idDevice = readValueFromConfig(await brComServiceInstance.pushService.localStorageKeyName(), 'idDevice');
    let params = {cod_empresa: codEmpresa, cod_usuario: codUsuario, id_device: idDevice};
    //console.log("chamando liberaUsuarioIdDevice params " + JSON.stringify(params));
    brComServiceInstance.remoteService.remoteCallSemLoading("liberaUsuarioIdDevice", params, function(result: any) {
    //  console.log("liberaUsuarioIdDevice "+JSON.stringify(result));
    })
  }

  async confirmaCpf(cpf: string, result: any) {
    let idDevice = readValueFromConfig(await brComServiceInstance.pushService.localStorageKeyName(), 'idDevice');
    var url = result.urlCadastrese + "&cpf=" + cpf + "&id_app_usuario=" + idDevice;
    //console.log("url is " + url);
    //console.log("device is " + idDevice);
    brComServiceInstance.iniciaPaginaNavegador(url);
  }

  async confirmaUsuarioLogado (codEmpresa: number, codUsuario: number){
    let idDevice = readValueFromConfig(await brComServiceInstance.pushService.localStorageKeyName(), 'idDevice');
    let params = {id_device: idDevice, cod_empresa: codEmpresa, cod_usuario: codUsuario}
    //console.log("confirmando se usuário está logado", JSON.stringify(params))
    brComServiceInstance.remoteService.remoteCallSemLoading('confirmaUsuarioLogadoPorDevice', params, function(result: any) {
      //console.log("usuario logado?: " + JSON.stringify(result));
      if (!result.isLogado) {
        brComServiceInstance.limpar();
      }
    })
  }


  criaMensagemLoading():Loading{
    return brComServiceInstance.loadingController.create({content:"Aguarde...",  duration: 15000});
  }

  iniciaTelaAutenticandoUsuariosValidos(usuarios: any[], cpf: string) {
      let codUsuarios = [];
      
      for(let usuario of usuarios) {
        let codUsuario = {
          "cod_empresa": usuario.CodEmpresa,
          "cod_usuario": usuario.CodUsuario
        }
        codUsuarios.push(codUsuario);
      }
  
      let params = {
        "cod_usuarios": JSON.stringify(codUsuarios),
        "imei": readValueFromConfig(brComServiceInstance.pushService.localStorageKeyName(), 'deviceCode')
        };
  
      brComServiceInstance.remoteService.remoteCallComLoading('validaUsuariosComSenhaPadrao', params, function (result : any) {
        if (result && result.length > 0) {
            let erro = false;
            for (let usuario of result) {
              if (usuario.executado) {
                brComServiceInstance.empresaAutenticadaComSenhaPadrao(usuario["codEmpresa"], usuario["codUsuario"]);
              } else {
                erro = true;
                brComServiceInstance.alertCtrl.create({ title: usuario.nomeEmpresa, message: usuario.msg, buttons: ["OK"] }).present();
              }
            }
            if (!(erro && result.length == 1)) {//quando tem erro e o usuário só tem uma empresa não entra na próxima tela
              brComServiceInstance.iniciaPaginaInicial({});
            }
        } else {
          brComServiceInstance.iniciaPaginaInicial({});
        }
    })
   
  }

  iniciaPaginaInicial(params: any) {
    brComServiceInstance.events.publish("iniciapagina:root:Inicial", params);
  }

  iniciaPaginaFoneCpf(params: any) {
    brComServiceInstance.events.publish("iniciapagina:root:FoneCpf", params);
  }

  iniciaPaginaConversaFiltro(codEmpresa: number, codUsuarioFiltro: number) {
    brComServiceInstance.events.publish("iniciapagina:push:Conversa", { codEmpresa: codEmpresa, codUsuarioFiltro: codUsuarioFiltro });
  }

  iniciaPaginaDenunciaRegistro(codEmpresa: number, denuncia?: any) {
    brComServiceInstance.events.publish("iniciapagina:push:DenunciaRegistro", { codEmpresa: codEmpresa, detalhesDenuncia: denuncia });
  }

  iniciaPaginaDenunciaLista(codEmpresa: number) {
    brComServiceInstance.events.publish("iniciapagina:push:DenunciaLista", { codEmpresa: codEmpresa });
  }

  iniciaPaginaDenunciaDeatalhes(denuncia: any) {
    brComServiceInstance.events.publish("iniciapagina:push:DenunciaDetalhes", {denuncia: denuncia});
  }

  iniciaPaginaConversaWatson(codEmpresa: number) {
    let codUsuario = brComServiceInstance.obtemCodUsuarioDaEmpresa(codEmpresa);
    brComServiceInstance.events.publish("iniciapagina:push:ConversaWatson", { codEmpresa: codEmpresa, codUsuario: codUsuario });
  }

  iniciarPaginaImagemGED(emailUsuario: string) {
    brComServiceInstance.events.publish("iniciapagina:push:ImagemGED", {email: emailUsuario});
  }

  iniciaPaginaNavegador(url:string) {
    brComServiceInstance.events.publish("iniciapagina:push:Navegador",{url: url});
  }

  obtemCodUsuarioDaEmpresa(codEmpresa: number): number {
    for (let grupo of brComServiceInstance.brComDao.obtemGrupos()) {
      if (grupo.CodEmpresa == codEmpresa)
        return grupo.CodUsuario;
    }
    return null;
  }

  obtemEmpresaPorCodigo(codEmpresa: number): any {
    for (let grupo of brComServiceInstance.brComDao.obtemGrupos()) {
      if (grupo.CodEmpresa == codEmpresa)
        return grupo;
    }
    return null;
  }

  obtemCodigoConfirmacao(): string {
    var text = "";
    var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 20; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  obtemImei(): string {
    return readValueFromConfig(brComServiceInstance.localStorageKeyName(), 'deviceCode');
  }

  obtemGrupo(codEmpresa: number, codUsuario: number): any {
    var grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos)
      if (grupo.CodEmpresa == codEmpresa && grupo.CodUsuario == codUsuario) {
        return grupo;
      }
    return null;
  }

  empresaAutenticadaComSenhaPersonalizada(codEmpresa: number, codUsuario: number) {
    var grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos)
      if (grupo.CodEmpresa == codEmpresa && grupo.CodUsuario == codUsuario) {
        grupo.Autenticado = true;
        grupo.MostrarMensagemTrocarSenhaPadrao = false;
        brComServiceInstance.brComDao.gravaGrupo(grupos);
        return;
      }
  }

  empresaAutenticadaComSenhaPadrao(codEmpresa: number, codUsuario: number) {
    var grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos)
      if (grupo.CodEmpresa == codEmpresa && grupo.CodUsuario == codUsuario) {
        grupo.Autenticado = true;
        grupo.MostrarMensagemTrocarSenhaPadrao = true;
        brComServiceInstance.brComDao.gravaGrupo(grupos);
        return;
      }
  }

  removerMensagemTrocarSenhaPadrao(codEmpresa: number, codUsuario: number) {
    var grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos)
      if (grupo.CodEmpresa == codEmpresa && grupo.CodUsuario == codUsuario) {
        grupo.MostrarMensagemTrocarSenhaPadrao = false;
        brComServiceInstance.brComDao.gravaGrupo(grupos);
        return;
      }
  }

  removeAutenticacao(codEmpresa: number, codUsuario: number) {
    var grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos)
      if (grupo.CodEmpresa == codEmpresa && grupo.CodUsuario == codUsuario) {
        grupo.Autenticado = false;
        brComServiceInstance.brComDao.gravaGrupo(grupos);
        return;
      }
  }

  obtemGrupos(): any[] {
    var r = brComServiceInstance.brComDao.obtemGrupos();
    if (r) {
      r.sort(function (a: any, b: any) {
        if (!a.NomeEmpresa || !b.NomeEmpresa)
          return 0;
        if (a.NomeEmpresa == b.NomeEmpresa)
          return 0;
        if (a.NomeEmpresa > b.NomeEmpresa)
          return 1;
        else
          return -1;
      });
      return r;
    }
    return r;
  }

  obtemTelefone(): string {
    return brComServiceInstance.brComDao.obtemTelefone();
  }

  gravaGrupo(grupos: any[]) {
    brComServiceInstance.brComDao.gravaGrupo(grupos);
  }

  obtemGrupoPorCodEmpresa(codEmpresa: number): any {
    return brComServiceInstance.brComDao.obtemGrupo(codEmpresa);
  }

  atualizadoDadosCliente(codEmpresa: number) {
    brComServiceInstance.remoteService.remoteCallSemLoading('infoEmpresa', { cod_empresa: codEmpresa }, function (result: any) {
      brComServiceInstance.brComDao.atualizaEmpresa(codEmpresa, result.infoEmpresa.atalhos, result.infoEmpresa.nomeEmpresa, result.infoEmpresa.hashLogotipo, result.infoEmpresa.site, 
        result.infoEmpresa.facebook, result.infoEmpresa.twitter, result.infoEmpresa.layoutRotinas);
      brComServiceInstance.events.publish("pagina.empresa.atualizada", codEmpresa);
    });
  }

  public async getUrlRedesSociaisEmpresa(codEmpresa: number) {
    const parametros = {
      cod_empresa: codEmpresa
    }
    brComServiceInstance.remoteService.remoteCallSemLoading('obterURLPlataformasSociaisEmpresa',parametros, function(result: any) {
      brComServiceInstance.brComDao.setRedesSociaisEmpresa(codEmpresa, result);
    })
  }

  obtemMensagensEmpresa(codEmpresa: number): any[] {
    return brComServiceInstance.brComDao.obtemMensagensEmpresa(codEmpresa);
  }

  async enviaMensagemTextoParaEmpresa(codEmpresa: number, mensagem: string) {
    let codUsuario = brComServiceInstance.obtemCodUsuarioDaEmpresa(codEmpresa);
    let idMsgLocal = brComServiceInstance.brComDao.enviaMensagemTextoParaEmpresa(codEmpresa, codUsuario, mensagem);
    let mensagemCodificadaHTML = encodeURIComponent(mensagem);
    const parametros = {
      emitente: "usuario." + codEmpresa + "." + codUsuario,
      recebedor: "empresa." + codEmpresa,
      texto: mensagemCodificadaHTML
    }
    //console.log(JSON.stringify(parametros));
    //console.log("enviaMensagemTextoParaEmpresa ====================================")
    brComServiceInstance.remoteService.remoteCallSemLoading('mensagemTexto', parametros, function (result: any) {
      brComServiceInstance.brComDao.atualizaSituacaoMensagemEnviada(codEmpresa, idMsgLocal, result.hexServidor);
    });
  }

  async enviaMensagemTextoRespostaDoAdmin(codEmpresa: number, codUsuarioDestino: number, mensagem: string) {
    let codUsuarioOrigem = brComServiceInstance.obtemCodUsuarioDaEmpresa(codEmpresa);
    let idMsgLocal = brComServiceInstance.brComDao.enviaMensagemTextoParaEmpresa(codEmpresa, codUsuarioDestino, mensagem);
    let mensagemCodificadaHTML = encodeURIComponent(mensagem);
    var emitente = "usuario." + codEmpresa + "." + codUsuarioOrigem;
    var recebedor = "usuario." + codEmpresa + "." + codUsuarioDestino;
    //console.log("enviaMensagemTextoRespostaDoAdmin ====================================")
    brComServiceInstance.remoteService.remoteCallSemLoading('mensagemTexto', {
      emitente: emitente,
      recebedor: recebedor,
      texto: mensagemCodificadaHTML
    }, function (result: any) {
      //console.log(mensagem);
      brComServiceInstance.brComDao.atualizaSituacaoMensagemEnviada(codEmpresa, idMsgLocal, result.hexServidor);
    });
  }

  enviaMensagensPendentes() {
    let grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos) {
      let msgs = brComServiceInstance.brComDao.listaMensagemPendenteEnvio(grupo.CodEmpresa);
      for (let msg of msgs) {
        //console.log("enviaMensagensPendentes ====================================")
        brComServiceInstance.remoteService.remoteCallSemLoading('mensagemTexto', {
          emitente: "usuario." + msg.codEmpresa + "." + msg.codUsuario,
          recebedor: "empresa." + msg.codEmpresa,
          texto: msg.mensagem
        }, function (result: any) {
          brComServiceInstance.brComDao.atualizaSituacaoMensagemEnviada(msg.codEmpresa, msg.idMsgLocal, result.hexServidor);
        });
      }
    }
  }

  notificaMensagemRecebidaPendente () {
    let grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos) {
      let msgs = brComServiceInstance.brComDao.listaMensagemRecebidasPendentes(grupo.CodEmpresa);
      for (let msg of msgs) {
        brComServiceInstance.notificaMensagemRecebida(msg);
      }
    }
  }

  atualizaListaMensagensNaoLidas() {
    let grupos = brComServiceInstance.brComDao.obtemGrupos();
    for (let grupo of grupos) {
      let msgs = brComServiceInstance.brComDao.listaMensagemNaoLidasPendentes(grupo.CodEmpresa);
      for (let msg of msgs) {
        brComServiceInstance.brComDao.adicionaMensagemNaoLida(msg);
      }
    }
  }

  obtemStatusMsgsNaoLidaEmpresa(codEmpresa: number): boolean {
    return brComServiceInstance.brComDao.getStatusMsgsNaoLidaEmpresa(codEmpresa);
  }

  abrePaginaComTipoURL(url: string) {
    let load =  brComServiceInstance.loadingController.create({content: "Aguarde ..."});
    load.present().then(
      () => {
        if (url.includes("id_login")) {
          brComServiceInstance.iniciaPaginaNavegador(url);
        } else {
          window.open(url, '_blank');
        }
        load.dismiss();
      });
  }

  abrePaginaNoBrowser(url: string) {
    window.open(url, '_blank');
  }

  mensagemCadastroNovo(codEmpresa: number, codUsuario: string, senha: string) {
    //console.log("mensagemCadastroNovo:FECHANDO_BROWSER");
    //console.log("mensagemCadastroNovo:codEmpresa:" + codEmpresa);
    //console.log("mensagemCadastroNovo:codUsuario:" + codUsuario);
    //console.log("mensagemCadastroNovo:senha:" + senha); 
    brComServiceInstance.browserTab.close();
  }

  dataHoraFormatado(): string {
    var date = new Date();
    let getFormattedDate = function () {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;

      return day + '/' + month + '/' + year;
    }
    let getFormattedHour = function () {
      let ss = date.toTimeString().split(' ')[0];
      return ss.substring(0, 8);
    }
    var r = getFormattedHour() + "_" + getFormattedDate();
    while (r.indexOf('/') != -1)
      r = r.replace('/', '');
    while (r.indexOf(':') != -1)
      r = r.replace(':', '');
    return r;
  }

  async gravaImagem(filePath: string): Promise<any> {

    let idDevice = readValueFromConfig(await brComServiceInstance.pushService.localStorageKeyName(), 'idDevice');
    let numeroLocal = keyGen('foto');
    let fileKey = 'brcomunique_D' + idDevice + 'L' + numeroLocal + '_H' + brComServiceInstance.dataHoraFormatado();
    const fileTransfer: FileTransferObject = brComServiceInstance.fileTransfer.create();
    let options: FileUploadOptions = {
      fileKey: 'file',
      fileName: fileKey,
      headers: {}
    }
    let urlPush = 'http://' + ServidorProvider.getIpPortaServidorPush()+ '/gopush/upload';
    fileTransfer.upload(filePath, urlPush, options).then((data) => {
      //console.log("FOTO:DONE" + JSON.stringify(data));
    }, (err) => {
      //console.log("FOTO:ERR" + JSON.stringify(err));
    });
    return { filePath: filePath, fileKey: fileKey }
  }

  public async gravarDenuncia(denuncia: any):Promise<any>{

    let params = {
      cod_empresa: denuncia.codEmpresa,
      cod_usuario: denuncia.codUsuario,
      titulo: denuncia.titulo,
      observacao: denuncia.observacao,
      numero_fotos: denuncia.fotos.length,
    };

    return await brComServiceInstance.remoteService.remote("gravaDenuncia", params)
  }

  public async getPageIdFacebook(): Promise<string> {
    let nomeApp = brComServiceInstance.readAppDomain();
    switch (nomeApp) {
      case "sindprevssc":
        return "365302130345860";
      case "sindprevssc3":
        return "365302130345860";
      case "aprasc":
        return "1451291975121885";
      case "fenapef":
        return "711288445579807";
      case "sindisprevrs":
        return "566919250076841";
      case "sinpofesc2":
        return "254090891357320";
      /*case "caben":
        return "100003741250833";  //100003741250833*/
      default:
        return "profile";
    };
  }

  mensagemFacebook(msg: any) {
    let codEmpresa = msg.codEmpresa;
    let empresa = brComServiceInstance.obtemEmpresaPorCodigo(codEmpresa);
    brComServiceInstance.facebook(empresa.Facebook);
  }

  public async facebook(urlFacebook: string) {
    const codePage = await brComServiceInstance.getPageIdFacebook();
    const nomeApp = brComServiceInstance.readAppDomain();

    if (nomeApp == "caben") {
      brComServiceInstance.browserTab.openUrl(urlFacebook);
      return;
    }

    brComServiceInstance.appAvailability.check("com.facebook.katana").then(
      function () {
        //console.log("entrou android")
        window.open("fb://page/" + codePage, '_system', 'location=no')
      }, function () {
        brComServiceInstance.appAvailability.check("fb://").then(
          function () {
            //console.log("entrou ios")
            window.open("fb://profile/" + codePage, '_system', 'location=no')
          }, function () {
            brComServiceInstance.browserTab.openUrl(urlFacebook);
          })
      }
    )
  };

 public geraLinkHtml(msg:any):string {
    return ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE +'/msg/' + msg.hashHTML + '.html';
 }
 
 public GerarMensagemErroPadrao(mensagem: string){
   brComServiceInstance.alertCtrl.create({
     title: "ERRO",
     message: mensagem,
     buttons: ["OK"]
   }).present();
 }


private montarHorarioData(data: Date):string{
  return brComServiceInstance.datePipe.transform(data, "HH:mm:ss");
}

private isDataHoje(data: Date):boolean{
  const dataHoje = new Date();
  const isMesmoDia = data.getDate() == dataHoje.getDate();
  const isMesmoMes = data.getMonth() == dataHoje.getMonth();
  const isMesmoAno = data.getFullYear() == dataHoje.getFullYear();
  return isMesmoDia && isMesmoMes && isMesmoAno;
}

private montarDiaData(data: Date) {
  return brComServiceInstance.datePipe.transform(data, "dd/MM/yyyy");
}

 public converterTimestampParaDataFormatadaString(data:Date):string {
  const horarioDenuncia = brComServiceInstance.montarHorarioData(data);

  if (brComServiceInstance.isDataHoje(data)){
    return horarioDenuncia;
  } else {
    return brComServiceInstance.converterTimestampParaDataComHorarioString(data);
  }
 }

 public converterTimestampParaDataComHorarioString(data:Date):string {
  const horarioDenuncia = brComServiceInstance.montarHorarioData(data);
  const dataDenuncia = brComServiceInstance.montarDiaData(data);
  return `${dataDenuncia} - ${horarioDenuncia}`;
 }

 public async enviarMensagemDenunciaAdmistradores(codUsuario: number, codEmpresa: number, titulo: string, observacao: string, 
  local: string, fotos: string[], data: string) {

    const parametros = {
      cod_usuario: codUsuario,
      cod_empresa: codEmpresa,
      titulo: titulo,
      observacao: observacao,
      local: local,
      fotos: encodeURIComponent(JSON.stringify(fotos)),
      data: data
    }

    brComServiceInstance.remoteService.remoteCallSemLoading('enviarDenunciaAdministradores', parametros, function (result){
    });

  }

  public async getCodEmpresaApp(): Promise<number> {
    const appDomain = brComServiceInstance.readAppDomain();
    switch(appDomain) {
      case "aprasc":
          return 162;
    }
  }

  public async getDadosRadio(): Promise<radio> {
    const appDomain = brComServiceInstance.readAppDomain();
    if (appDomain == "aprasc") {
      return {
        link: "http://hts03.kshost.com.br:8176/live",
        //link: "http://107.191.38.218:9148/live",
        titulo: "Rádio APRASC (ao vivo)"
      }
    }
  }

  public obtemUrlLogotipoEmpresa(hashLogotipo: string):string {
    return ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE + "/api/v1/file/download/"+hashLogotipo+"/I/50/"+hashLogotipo+".jpg";
  }
}


// WEBPACK FOOTER //
// ./src/service/BrComService.ts